import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Layout from 'components/Layout'
import Gallery from './index/Gallery'
import DentistsSection from './index/DentistsSection'
import TreatmentsSection from './index/TreatmentsSection'
import FourKeyPoints from './index/FourKeyPoints'
import MissionStatement from './index/MissionStatement'
import Memberships from './index/Memberships'
import InstagramPosts from './index/InstagramPosts'
import GoogleReviews from './index/GoogleReviews'
// import CovidDialog from './index/CovidDialog'
// import PromoDialog from './index/PromoDialog'

const Index = () => (
  <Layout>
    <div>
      <Helmet
        title="Oregon City Smiles | Family Dentistry in Oregon City, OR"
        meta={[
          {
            name: 'description',
            content:
              'Providing comprehensive family dental care in Oregon City, Oregon. Our dental practice offers general dentistry, cosmetic procedures, and emergency dental services in a caring environment.'
          },
          {
            name: 'keywords',
            content:
              'dentist Oregon City, family dentistry, dental care Oregon City OR, cosmetic dentistry, emergency dental services, dental implants, teeth whitening, oregon city dentist'
          },
          {
            name: 'author',
            content: 'Oregon City Smiles'
          },
          {
            property: 'og:title',
            content: 'Oregon City Smiles | Family Dentistry in Oregon City, OR'
          },
          {
            property: 'og:description',
            content:
              'Providing comprehensive family dental care in Oregon City, Oregon. Our dental practice offers general dentistry, cosmetic procedures, and emergency dental services.'
          },
          {
            property: 'og:type',
            content: 'website'
          },
          {
            property: 'og:url',
            content: 'https://oregoncitysmiles.com'
          },
          {
            property: 'og:site_name',
            content: 'Oregon City Smiles'
          },
          {
            name: 'twitter:card',
            content: 'summary_large_image'
          },
          {
            name: 'twitter:title',
            content: 'Oregon City Smiles | Family Dentistry in Oregon City, OR'
          },
          {
            name: 'twitter:description',
            content:
              'Providing comprehensive family dental care in Oregon City, Oregon. Our dental practice offers general dentistry, cosmetic procedures, and emergency dental services.'
          },
          {
            name: 'robots',
            content: 'index, follow'
          },
          {
            name: 'googlebot',
            content: 'index, follow'
          },
          {
            name: 'language',
            content: 'English'
          },
          {
            name: 'geo.region',
            content: 'US-OR'
          },
          {
            name: 'geo.placename',
            content: 'Oregon City, Oregon'
          },
          {
            name: 'geo.position',
            content: '45.320322;-122.5802065'
          },
          {
            name: 'ICBM',
            content: '45.320322, -122.5802065'
          }
        ]}
        script={[
          {
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Dentist',
              name: 'Oregon City Smiles',
              description:
                'Providing comprehensive family dental care in Oregon City, Oregon',
              url: 'https://oregoncitysmiles.com',
              telephone: '(503) 518-3384',
              address: {
                '@type': 'PostalAddress',
                streetAddress: '19731 South Hwy 213',
                addressLocality: 'Oregon City',
                addressRegion: 'OR',
                postalCode: '97045',
                addressCountry: 'US'
              },
              geo: {
                '@type': 'GeoCoordinates',
                latitude: 45.320322,
                longitude: -122.5802065
              },
              openingHours: ['Mo-Th 08:00-17:00'],
              priceRange: '$$',
              paymentAccepted: 'Cash, Credit Card, Insurance',
              currenciesAccepted: 'USD'
            })
          }
        ]}
      />

      {/* OCS-style Hero Section */}
      <div
        className="relative overflow-hidden"
        style={{
          background:
            'linear-gradient(135deg, #0a2540 0%, #1a1f36 50%, #635bff 100%)',
          minHeight: '600px'
        }}
      >
        {/* Gradient Mesh Background */}
        <div
          className="absolute inset-0 opacity-30"
          style={{
            background:
              'radial-gradient(ellipse at 20% 50%, #11efe3 0%, transparent 50%), radial-gradient(ellipse at 80% 80%, #ff80b5 0%, transparent 50%), radial-gradient(ellipse at 40% 20%, #635bff 0%, transparent 40%)'
          }}
        />

        {/* Content */}
        <div
          className="relative z-10 container mx-auto px-6 py-24 flex flex-col items-center justify-center text-center"
          style={{ minHeight: '600px' }}
        >
          {/* Badge */}
          <div
            className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium mb-8"
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(10px)',
              color: '#ffffff',
              border: '1px solid rgba(255, 255, 255, 0.2)'
            }}
          >
            <span
              className="w-2 h-2 rounded-full bg-green mr-2"
              style={{ backgroundColor: '#33c27f' }}
            ></span>
            Now accepting new patients
          </div>

          <h1
            className="text-white font-bold mb-6 leading-tight"
            style={{
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              letterSpacing: '-0.03em',
              maxWidth: '800px'
            }}
          >
            Modern dental care for your whole family
          </h1>

          <p
            className="text-lg mb-10 leading-relaxed"
            style={{
              color: 'rgba(255, 255, 255, 0.8)',
              maxWidth: '600px'
            }}
          >
            Conveniently located on Highway 213 in Oregon City, Oregon. Our
            office provides exceptional dentistry in a unique, caring
            environment.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/appointments"
              className="px-8 py-4 bg-primary text-white font-semibold text-base rounded-lg transition-all duration-150 hover:bg-primaryDark"
              style={{
                boxShadow: '0 4px 14px 0 rgba(99, 91, 255, 0.39)'
              }}
            >
              Schedule an Appointment
            </Link>
            <Link
              to="/about_us"
              className="px-8 py-4 font-semibold text-base rounded-lg transition-all duration-150"
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                color: '#ffffff',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                backdropFilter: 'blur(10px)'
              }}
            >
              Meet Our Team
            </Link>
          </div>
        </div>

        {/* Gallery positioned at bottom */}
        <Gallery />
      </div>

      <MissionStatement />
      <FourKeyPoints />
      <Memberships />
      <TreatmentsSection />
      <DentistsSection />
      {/* <InstagramPosts /> */}
      <GoogleReviews />
    </div>
  </Layout>
)

export default Index
